<template>
  <div>
    <div class="module_addi">
      <el-select v-model="year" @change="listVisit()" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="btn_outer">
        <el-button type="primary" plain @click="toAddvisit"><i class="cloudicon ci_modify"></i> 数据填报</el-button>
      </div>
    </div>
    <div class="user_module">
      <div class="module_head">
        <div>
          走访记录
        </div>
        <div>
          <!--<img :src="imgUrl+'icon_more.png'"/>-->
        </div>
      </div>
      <div class="module_list_outer">
        <div class="module_list" v-for="(item,index) in xmData">
          <div class="cl" style="width: 35%;">
            <div class="cl_col1 xm_name"  @click="view(item.id)">
              {{ `第${item.quarter}季度` }}
            </div>
          </div>
          <div class="cl" style="width: 15%;">
            <div class="q q9">
              走访时间
            </div>
            <div class="fs lh">
              {{ item.tb_date }}
            </div>
          </div>
          <div class="cl" style="width: 15%;">
            <div class="q q9">
              走访人
            </div>
            <div class="fs">
              {{ item.zf_name }}
            </div>
          </div>
          <div class="cl" style="width: 15%;">
            <div class="q q9">
              处理进度
            </div>
            <div class="stc" :class="{statsubm:item.statusname.indexOf('填写')>-1,stathand:item.statusname.indexOf('提交')>-1}" style="font-size: 14px;">
              {{ item.statusname }}
            </div>
          </div>
          <div class="cl" style="width: 20%;">
          	<div class="q q9">
          		操作
          	</div>
          	<div class="operate_outer">
          		<span class="btn_edi" v-if="item.statusname==='正在填写'" @click="modify(item.id)" style="font-size: 14px;">编辑</span>
          		<!--<span class="btn_able" style="margin-left: 14px;font-size: 14px;" @click="view(item.id)">查看</span>-->
          	</div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        :current-page="currentPage"
        :page-size="pagesize"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      @close="close"
      width="1080px">
      <addvisit @emitClose="close"></addvisit>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisibleEdit"
      @close="close2"
      width="1080px">
      <editvisit @emitEditClose="close2"  v-if="dialogVisibleEdit" :editId="editId" :mode="mode" ></editvisit>
    </el-dialog>

  </div>
</template>

<script>
export default {
  created() {
    this.listVisit();
  },
  name: 'uservisit',
  inject:['reload'],
  data() {
    return {
      total:0,
      currentPage: 1,
      pagesize: 10,
      xmData: [],
      options: [{
        value: '2020',
        label: '2020'
      }, {
        value: '2019',
        label: '2019'
      }, {
        value: '2018',
        label: '2018'
      }],
      year: '2020',
      value2: '',
      dialogVisible: false,
      dialogVisibleEdit: false,
      editId: '',
      mode: ''
    }
  },
  methods: {
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
   async toAddvisit() {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/interview/getId');
      if(res.data.data.submited==0){
        this.$message.error('当前不在申报期，暂不可填报');
        return
      }
     if(res.data.data.submited==1){
       this.$message.error('本申报期仅可填报一次！');
       return
     }

     if (res.data.data.year != null && res.data.data.quarter != null && res.data.data.submited==2) {
        this.dialogVisible = true
      } else {
        this.$message.error('暂不可填报');
      }
    },
    close() {
      this.dialogVisible = false
      this.reload()
    },
    modify(id){
    	this.editId = id;
    	this.dialogVisibleEdit = true;
      this.mode='edit';
    },

    view(id){
      this.editId = id;
      this.dialogVisibleEdit = true;
      this.mode='view';
    },
    close2() {
      this.dialogVisibleEdit = false
      this.reload()
    },
    async listVisit() {
      this.options=[];
      var curryear=new Date().getFullYear();
      this.year=curryear;
      for (var i=curryear;i>=2018;i--){
        var option={
          value: ''+i,
          label: ''+i
        }
        this.options.push(option)
      }
      let res = await this.$ajax.post(this.bUrl + 'api/portal/interview/index?year='+this.year+"&page="+this.currentPage+"&pagesize="+this.pagesize);
      this.xmData=res.data.data.list;
      this.total=res.data.data.total;
      if(res.data.code!=200){
        this.$message.error(res.data.msg);
      }
    }
  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.module_tab_cont {
  margin-top: 25px;
}

.module_addi {
  width: 100%;
  margin: 10px 0 30px 0;
  display: flex;
  justify-content: space-between;
}

.module_addi .p {
  color: #6F88AF;
}

.ci_modify {
  font-size: 24px;
}


.module_list .xm_name {
  width: 200px;
}

.module_list .stc {
  /*color: #72A757;*/
}

.module_list .statsubm {
  color: #F0C78A;
}

.module_list .stathand {
  color: #72A757;
}

.module_list .cl {
  margin-right: 24px;
}
.operate_outer span{
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/user/uservisit.vue